import { useTranslation } from "react-i18next";
import isMobile from "src/helpers/isMobile";

import EmptyBox from "../../../Main/EmptyBox";
import ExamListCard from "../../../Main/ExamsBox/ExamsListCard";
import ExamsShortViewSkeleton from "../../Skeletons/ExamsShortView";

export default function DefaultView(props) {
	const { t } = useTranslation();

	if (props.isLoading) {
		return <ExamsShortViewSkeleton />;
	}

	if (!(props.rows || []).length) {
		return (
			<EmptyBox
				title={t("table.exam.empty.title")}
				subtitle={t("table.exam.empty.submitText")}
			/>
		);
	}

	const getRows = () => {
		return props.rows.slice(0, isMobile() ? 1 : props.rowsToShow);
	};

	return <ExamListCard rows={getRows()} />;
}
